import { Injectable } from "@angular/core";
import { CoreHttpClient } from "@obg/ngx.core";
import { Observable } from "rxjs";

import { MissingPasswordConfigService } from "./missing-password.config";
import { MissingPasswordModel } from "./missing-password.model";

/**
 * @deprecated - [fabric-deprecated] - Use MissingPasswordService from app-account mfe instead
 */
@Injectable({
	providedIn: "root",
})
export class MissingPasswordClient {
	constructor(
		private config: MissingPasswordConfigService,
		private httpClient: CoreHttpClient
	) {}

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.SetMissingPassword) instead
	 */
	set({ newPassword, token }: MissingPasswordModel): Observable<object> {
		return this.httpClient.post({
			url: this.config.getMissingPasswordEndpoint(),
			data: {
				newPassword,
				token,
			},
		});
	}
}
